import { InputFromUser } from '../../../components/Input/input';

/**
 * Reusable text input field component
 */
export const TextField = ({
    label,
    name,
    value,
    onChange,
    onBlur,
    touched,
    error,
    placeholder,
    disabled = false,
    colClass = 'col-xl-4 col-md-6 col-12'
}) => {
    return (
        <InputFromUser
            label={label}
            type="text"
            FormGroupClassName={colClass}
            LabelClassName={'col-form-label'}
            name={name}
            onChange={onChange}
            FormControlClassName={'form-control'}
            onBlur={onBlur}
            value={value}
            touched={touched}
            error={error}
            placeholder={placeholder}
            disabled={disabled}
        />
    );
};

/**
 * Reusable textarea field component
 */
export const TextAreaField = ({
    label,
    name,
    value,
    onChange,
    onBlur,
    placeholder,
    disabled = false,
    rows = 10,
    colClass = 'col-xl-6 col-md-6 col-12'
}) => {
    return (
        <div className={colClass}>
            <div className="form-group">
                <label className="col-form-label">{label}:</label>
                <textarea
                    rows={rows}
                    className="form-control"
                    placeholder={placeholder}
                    value={value}
                    onBlur={onBlur}
                    onChange={onChange}
                    disabled={disabled}
                />
            </div>
        </div>
    );
};

/**
 * Reusable radio button field component
 */
export const RadioField = ({
    label,
    name,
    value,
    selectedValue,
    onChange,
    onBlur,
    options,
    disabled = false,
    colClass = 'col-xl-4 col-md-6 col-12'
}) => {
    return (
        <InputFromUser
            label={label}
            type="radio"
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            FormControlClassName={'form-control'}
            FormGroupClassName={colClass}
            LabelClassName={'col-form-label'}
            value={value}
            selectedValue={selectedValue}
            options={options}
            disabled={disabled}
        />
    );
};

/**
 * Reusable date field component
 */
export const DateField = ({
    label,
    name,
    value,
    onChange,
    onBlur,
    placeholder,
    disabled = false,
    colClass = 'col-xl-4 col-md-6 col-12'
}) => {
    return (
        <InputFromUser
            label={label}
            type="date"
            FormGroupClassName={colClass}
            LabelClassName={'col-form-label'}
            FormControlClassName={'form-control'}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            placeholder={placeholder}
            disabled={disabled}
        />
    );
};
/**
 * Reusable time field component
 */
export const TimeField = ({
    label,
    name,
    value,
    onChange,
    onBlur,
    placeholder,
    disabled = false,
    colClass = 'col-xl-4 col-md-6 col-12'
}) => {
    return (
        <InputFromUser
            label={label}
            type="TimePicker"
            FormGroupClassName={colClass}
            LabelClassName={'col-form-label'}
            FormControlClassName={'form-control'}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            placeholder={placeholder}
            disabled={disabled}
        />
    );
};

/**
 * Reusable select field component
 */
export const SelectField = ({
    label,
    name,
    value,
    onChange,
    onBlur,
    options,
    placeholder,
    disabled = false,
    colClass = 'col-xl-4 col-md-6 col-12'
}) => {
    return (
        <InputFromUser
            label={label}
            type="singleSelect"
            FormGroupClassName={colClass}
            LabelClassName={'col-form-label'}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            options={options}
            placeholder={placeholder}
            disabled={disabled}
        />
    );
};
